"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = exports.COLLAPSIBLE_SIDEBAR_CLOSED_WIDTH = exports.SidebarSide = void 0;
const react_1 = require("@chakra-ui/react");
const framer_motion_1 = require("framer-motion");
const react_2 = __importStar(require("react"));
const bs_1 = require("react-icons/bs");
const hooks_1 = require("../hooks");
const animation_1 = require("../utils/animation");
const colors_1 = require("../utils/colors");
const ModalCloseButton_1 = require("./ModalCloseButton");
var SidebarSide;
(function (SidebarSide) {
    SidebarSide["Left"] = "Left";
    SidebarSide["Right"] = "Right";
})(SidebarSide = exports.SidebarSide || (exports.SidebarSide = {}));
exports.COLLAPSIBLE_SIDEBAR_CLOSED_WIDTH = '40px';
const TRANSITION = {
    ease: 'easeOut',
    duration: 0.2,
};
const LEFT_INITIAL_STATE = {
    opacity: 0.5,
    translateX: -100,
    transition: TRANSITION,
};
const RIGHT_INITIAL_STATE = {
    opacity: 0.5,
    translateX: 100,
    transition: TRANSITION,
};
const BASE_STATE = {
    opacity: 1,
    translateX: 0,
    transition: TRANSITION,
};
const Sidebar = ({ isOpen: externalIsOpen, setIsOpen: externalSetIsOpen, title, children, side = SidebarSide.Left, width = '300px', tabs, tabButtonProps, tabContainerProps, containerProps, }) => {
    var _a;
    const [activeTabIndex, setActiveTabIndex] = (0, react_2.useState)(0);
    const isLeft = (0, react_2.useMemo)(() => side === SidebarSide.Left, [side]);
    const isMobile = (0, hooks_1.useIsMobile)();
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const [internalIsOpen, internalSetIsOpen] = (0, react_2.useState)(true);
    const [isOpen, setIsOpen] = (0, react_2.useMemo)(() => {
        return [externalIsOpen !== null && externalIsOpen !== void 0 ? externalIsOpen : internalIsOpen, externalSetIsOpen !== null && externalSetIsOpen !== void 0 ? externalSetIsOpen : internalSetIsOpen];
    }, [externalIsOpen, externalSetIsOpen, internalIsOpen]);
    const handleToggle = (0, react_2.useCallback)(() => {
        setIsOpen((o) => !o);
    }, [setIsOpen]);
    const initialTransitionState = (0, react_2.useMemo)(() => (isLeft ? LEFT_INITIAL_STATE : RIGHT_INITIAL_STATE), [isLeft]);
    return (react_2.default.createElement(react_1.Flex, Object.assign({ position: isMobile ? 'absolute' : 'initial', zIndex: 4, bgColor: "black", top: 0, bottom: 0, right: 0, left: !isLeft && !isOpen ? 'calc(100vw - 40px)' : 0, w: isOpen ? (isMobile ? '100%' : width) : exports.COLLAPSIBLE_SIDEBAR_CLOSED_WIDTH, transition: "left 0.2s, width 0.2s", borderColor: primaryColor, borderRightWidth: !isLeft || (isOpen && isMobile) ? 0 : '1px', borderLeftWidth: isLeft || (isOpen && isMobile) ? 0 : '1px', direction: "column" }, containerProps), tabs ? (react_2.default.createElement(react_1.Flex, { h: "full" },
        react_2.default.createElement(react_1.Box, Object.assign({ width: exports.COLLAPSIBLE_SIDEBAR_CLOSED_WIDTH, h: "full", borderColor: primaryColor, borderLeftWidth: isLeft && isOpen ? '1px' : 0, borderRightWidth: !isLeft && isOpen ? '1px' : 0 }, tabContainerProps), tabs.map((tab, index) => {
            const isActiveTab = index === activeTabIndex;
            const isFilled = isActiveTab && isOpen;
            return (react_2.default.createElement(react_1.AspectRatio, { key: index, ratio: 1 },
                react_2.default.createElement(react_1.Flex, Object.assign({ borderBottomColor: primaryColor, borderBottomWidth: "1px", bgColor: isFilled ? primaryColor : 'black', color: isFilled ? 'black' : primaryColor, cursor: "pointer", _hover: {
                        bgColor: isFilled
                            ? (0, colors_1.alphaColor)(primaryColor, 0.7)
                            : (0, colors_1.alphaColor)(primaryColor, 0.1),
                    }, _active: {
                        bgColor: isFilled
                            ? (0, colors_1.alphaColor)(primaryColor, 0.9)
                            : (0, colors_1.alphaColor)(primaryColor, 0.2),
                    }, onClick: () => {
                        if (isActiveTab) {
                            handleToggle();
                        }
                        else {
                            setActiveTabIndex(index);
                        }
                    } }, tabButtonProps, tab.containerProps), react_2.default.createElement(tab.icon))));
        })),
        react_2.default.createElement(framer_motion_1.AnimatePresence, null, isOpen && (react_2.default.createElement(animation_1.MotionBox, { initial: initialTransitionState, animate: BASE_STATE, exit: initialTransitionState, flex: 1, position: "relative", overflowY: "auto" },
            react_2.default.createElement(ModalCloseButton_1.ModalCloseButton, { onClose: handleToggle }), (_a = tabs[activeTabIndex]) === null || _a === void 0 ? void 0 :
            _a.content))))) : (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.Flex, { px: 2, py: 2, borderColor: primaryColor, borderBottomWidth: "1px", onClick: handleToggle, cursor: "pointer", alignItems: "center", justifyContent: isLeft ? 'flex-end' : 'flex-start', minH: "41px" },
            react_2.default.createElement(framer_motion_1.AnimatePresence, null, isLeft && isOpen && title && (react_2.default.createElement(animation_1.MotionFlex, { initial: initialTransitionState, animate: BASE_STATE, exit: initialTransitionState, color: "white", flex: 1, justifyContent: "flex-start" }, title))),
            react_2.default.createElement(react_1.Box, { fontSize: "1.25rem" }, (isLeft && isOpen) || (!isLeft && !isOpen) ? (react_2.default.createElement(bs_1.BsArrowBarLeft, null)) : (react_2.default.createElement(bs_1.BsArrowBarRight, null))),
            react_2.default.createElement(framer_motion_1.AnimatePresence, null, !isLeft && isOpen && title && (react_2.default.createElement(animation_1.MotionFlex, { initial: initialTransitionState, animate: BASE_STATE, exit: initialTransitionState, color: "white", flex: 1, justifyContent: "flex-end" }, title)))),
        react_2.default.createElement(framer_motion_1.AnimatePresence, null, isOpen && (react_2.default.createElement(animation_1.MotionBox, { initial: initialTransitionState, animate: BASE_STATE, exit: initialTransitionState, flex: 1, overflowY: "auto" }, children)))))));
};
exports.Sidebar = Sidebar;
//# sourceMappingURL=Sidebar.js.map